import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
// import store from '../store'
import { getStorage } from '@/assets/js/storage'
import store from '../store'; // ajuste o caminho se necessário

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: { headerTitle: 'Início'}
  },
  {
    path: '/forgot-password/:string',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "home" */ '../views/ForgotPasswordView.vue'),
    // eslint-disable-next-line no-unused-vars
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Customer/CustomersView.vue'),
    meta: { headerTitle: 'Cliente'}
  },
  {
    path: '/customer/create',
    name: 'customerCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Customer/CustomerCreateView.vue'),
    meta: { headerTitle: 'Cliente'}
  },
  {
    path: '/customer/:id/show',
    name: 'customerView',
    component: () => import(/* webpackChunkName: "customerView" */ '../views/Customer/CustomerView.vue'),
    meta: { headerTitle: 'Cliente'}
  },
  {
    path: '/customer/:id/edit',
    name: 'customerEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Customer/CustomerEditView.vue'),
    meta: { headerTitle: 'Cliente'}
  },
  {
    path: '/prescriber',
    name: 'prescriber',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Prescriber/PrescribersView.vue'),
    meta: { headerTitle: 'Prescritor'}
  },
  {
    path: '/prescriber/create',
    name: 'prescriberCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Prescriber/PrescriberCreateView.vue'),
    meta: { headerTitle: 'Prescritor'}
  },
  {
    path: '/prescriber/:id',
    name: 'prescriberEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Prescriber/PrescriberEditView.vue'),
    meta: { headerTitle: 'Prescritor'}
  },
  {
    path: '/prescriber/:id/show',
    name: 'prescriberShow',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Prescriber/PrescriberView.vue'),
    meta: { headerTitle: 'Prescritor'}
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Product/ProductsView.vue'),
    meta: { headerTitle: 'Produtos'}
  },
  {
    path: '/product/groups',
    name: 'productGroups',
    component: () => import(/* webpackChunkName: "productGroups" */ '../views/ProductGroups/ProductGroupsView.vue'),
    meta: { headerTitle: 'Grupo de Produtos'}
  },
  {
    path: '/order',
    name: 'order',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Order/OrdersView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/order/create',
    name: 'orderCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Order/OrderCreateView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/order/:id',
    name: 'orderView',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Order/OrderView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/order/edit/:id',
    name: 'orderEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Order/OrderEditView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/order/success/:id',
    name: 'orderSuccess',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Order/OrderSucessView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/service',
    name: 'ordersService',
    component: () => import(/* webpackChunkName: "ordersService" */ '../views/Service/OrdersServiceView.vue'),
    meta: { headerTitle: 'Serviços - Venda'}
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "customer" */ '../views/User/UsersView.vue'),
    meta: { headerTitle: 'Usuários'}
  },
  {
    path: '/user/create',
    name: 'userCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/User/UserCreateView.vue'),
    meta: { headerTitle: 'Usuários'}
  },
  {
    path: '/user/:id',
    name: 'userEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/User/UserEditView.vue'),
    meta: { headerTitle: 'Usuários'}
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Permission/PermissionsView.vue'),
    meta: { headerTitle: 'Permissões'}
  },
  {
    path: '/permission/create',
    name: 'permissionCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Permission/PermissionCreateView.vue'),
    meta: { headerTitle: 'Permissões'}
  },
  {
    path: '/permission/:id',
    name: 'permissionEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Permission/PermissionEditView.vue'),
    meta: { headerTitle: 'Permissões'}
  },
  {
    path: '/access-query',
    name: 'accessQuery',
    component: () => import(/* webpackChunkName: "accessQuery" */ '../views/Access/AccessQueryView.vue'),
    meta: { headerTitle: 'Permissões'}
  },
  {
    path: '/role',
    name: 'roles',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Role/RolesView.vue'),
    meta: { headerTitle: 'Grupos de Acesso'}
  },
  {
    path: '/role/create',
    name: 'roleCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Role/RoleCreateView.vue'),
    meta: { headerTitle: 'Grupos de Acesso'}
  },
  {
    path: '/role/:id',
    name: 'roleEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Role/RoleEditView.vue'),
    meta: { headerTitle: 'Grupos de Acesso'}
  },
  {
    path: '/system/logs/views',
    name: 'systemLogs',
    component: () => import(/* webpackChunkName: "systemLogs" */ '../views/SystemLogs/SystemLogsViews.vue'),
    meta: { headerTitle: 'Logs de Sistema'}
  },
  {
    path: '/system/logs/login',
    name: 'systemLoginLogs',
    component: () => import(/* webpackChunkName: "systemLoginLogs" */ '../views/SystemLogs/SystemLoginLogsViews.vue'),
    meta: { headerTitle: 'Logs de Login'}
  },
  {
    path: '/enterprise',
    name: 'enterprises',
    component: () => import(/* webpackChunkName: "customer" */ '../views/Enterprise/EnterprisesView.vue'),
    meta: { headerTitle: 'Empresa'}
  },
  {
    path: '/enterprise/create',
    name: 'enterpriseCreate',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Enterprise/EnterpriseCreateView.vue'),
    meta: { headerTitle: 'Empresa'}
  },
  {
    path: '/enterprise/:id',
    name: 'enterpriseEdit',
    component: () => import(/* webpackChunkName: "customerEdit" */ '../views/Enterprise/EnterpriseEditView.vue'),
    meta: { headerTitle: 'Empresa'}
  },
  {
    path: '/type-order',
    name: 'typeOrder',
    component: () => import(/* webpackChunkName: "typeOrder" */ '../views/TypeOrder/TypeOrdersView.vue'),
    meta: { headerTitle: 'Tipo de Pedidos'}
  },
  {
    path: '/type-order/create',
    name: 'typeOrderCreate',
    component: () => import(/* webpackChunkName: "typeOrderCreate" */ '../views/TypeOrder/TypeOrderCreateView.vue'),
    meta: { headerTitle: 'Tipo de Pedidos'}
  },
  {
    path: '/type-order/:id',
    name: 'typeOrderEdit',
    component: () => import(/* webpackChunkName: "typeOrderEdit" */ '../views/TypeOrder/TypeOrderEditView.vue'),
    meta: { headerTitle: 'Tipo de Pedidos'}
  },
  {
    path: '/type-exchange',
    name: 'typeExchange',
    component: () => import(/* webpackChunkName: "typeExchange" */ '../views/TypeExchange/TypeExchangesView.vue'),
    meta: { headerTitle: 'Tipo de Troca'}
  },
  {
    path: '/type-exchange/create',
    name: 'typeExchangeCreate',
    component: () => import(/* webpackChunkName: "typeExchangeCreate" */ '../views/TypeExchange/TypeExchangeCreateView.vue'),
    meta: { headerTitle: 'Tipo de Troca'}
  },
  {
    path: '/type-exchange/:id',
    name: 'typeExchangeEdit',
    component: () => import(/* webpackChunkName: "typeExchangeEdit" */ '../views/TypeExchange/TypeExchangeEditView.vue'),
    meta: { headerTitle: 'Tipo de Troca'}
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import(/* webpackChunkName: "payment" */ '../views/Payment/PaymentsView.vue'),
    meta: { headerTitle: 'Formas de Pagamento'}
  },
  {
    path: '/payment/create',
    name: 'paymentCreate',
    component: () => import(/* webpackChunkName: "paymentCreate" */ '../views/Payment/PaymentCreateView.vue'),
    meta: { headerTitle: 'Formas de Pagamento'}
  },
  {
    path: '/payment/:id',
    name: 'paymentEdit',
    component: () => import(/* webpackChunkName: "paymentEdit" */ '../views/Payment/PaymentEditView.vue'),
    meta: { headerTitle: 'Formas de Pagamento'}
  },
  {
    path: '/order/info/:id/:type',
    name: 'OrderInfo',
    component: () => import(/* webpackChunkName: "OrderInfo" */ '../views/Order/OrderInfoView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/type-rental',
    name: 'typeRental',
    component: () => import(/* webpackChunkName: "typeRental" */ '../views/TypeRental/TypeRentalsView.vue'),
    meta: { headerTitle: 'Tipos de Locação'}
  },
  {
    path: '/type-rental/create',
    name: 'typeRentalCreate',
    component: () => import(/* webpackChunkName: "typeRentalCreate" */ '../views/TypeRental/TypeRentalCreateView.vue'),
    meta: { headerTitle: 'Tipos de Locação'}
  },
  {
    path: '/type-rental/:id',
    name: 'typeRentalEdit',
    component: () => import(/* webpackChunkName: "typeRentalEdit" */ '../views/TypeRental/TypeRentalEditView.vue'),
    meta: { headerTitle: 'Tipos de Locação'}
  },
  {
    path: '/type-adress',
    name: 'typeAdress',
    component: () => import(/* webpackChunkName: "typeAdress" */ '../views/TypeAdress/TypeAdressView.vue'),
    meta: { headerTitle: 'Tipos de Endereçamento'}
  },
  {
    path: '/type-adress/create',
    name: 'typeAdressCreate',
    component: () => import(/* webpackChunkName: "typeAdressCreate" */ '../views/TypeAdress/TypeAdressCreateView.vue'),
    meta: { headerTitle: 'Tipos de Endereçamento'}
  },
  {
    path: '/type-adress/:id',
    name: 'typeAdressEdit',
    component: () => import(/* webpackChunkName: "typeAdressEdit" */ '../views/TypeAdress/TypeAdressEditView.vue'),
    meta: { headerTitle: 'Tipos de Endereçamento'}
  },
  {
    path: '/type-storage',
    name: 'typeStorage',
    component: () => import(/* webpackChunkName: "typeStorage" */ '../views/TypeStorage/TypeStoragesView.vue'),
    meta: { headerTitle: 'Tipos de Armazenamento'}
  },
  {
    path: '/type-storage/create',
    name: 'typeStorageCreate',
    component: () => import(/* webpackChunkName: "typeStorageCreate" */ '../views/TypeStorage/TypeStorageCreateView.vue'),
    meta: { headerTitle: 'Tipos de Armazenamento'}
  },
  {
    path: '/type-storage/:id',
    name: 'typeStorageEdit',
    component: () => import(/* webpackChunkName: "typeStorageEdit" */ '../views/TypeStorage/TypeStorageEditView.vue'),
    meta: { headerTitle: 'Tipos de Armazenamento'}
  },
  {
    path: '/type-products-logistic',
    name: 'typeProductLogistic',
    component: () => import(/* webpackChunkName: "typeStorage" */ '../views/TypeProductLogistic/TypeProductsLogisticView.vue'),
    meta: { headerTitle: 'Gerência - Localização de Produtos'}
  },
  {
    path: '/type-products-logistic/logs',
    name: 'typeProductLogisticLogs',
    component: () => import(/* webpackChunkName: "typeProductLogisticLogs" */ '../views/TypeProductLogistic/TypeProductLogisticLogsView.vue'),
    meta: { headerTitle: 'Gerência - Logs'}
  },
  {
    path: '/deadline',
    name: 'deadline',
    component: () => import(/* webpackChunkName: "deadline" */ '../views/Deadline/DeadlinesView.vue'),
    meta: { headerTitle: 'Planos' }
  },
  {
    path: '/deadline/create',
    name: 'deadlineCreate',
    component: () => import(/* webpackChunkName: "deadlineCreate" */ '../views/Deadline/DeadlineCreateView.vue'),
    meta: { headerTitle: 'Planos' }
  },
  {
    path: '/deadline/:id',
    name: 'deadlineEdit',
    component: () => import(/* webpackChunkName: "typeRentalEdit" */ '../views/Deadline/DeadlineEditView.vue'),
    meta: { headerTitle: 'Planos' }
  },
  {
    path: '/rental-demand-report',
    name: 'rentalDemandReport',
    component: () => import(/* webpackChunkName: "rentalDemandReport" */ '../views/Rental/DemandReport/DemandReportView.vue'),
    meta: { headerTitle: 'Análise de Giro - Relatório' }
  },
  {
    path: '/rental-stock-request',
    name: 'rentalStockRequest',
    component: () => import(/* webpackChunkName: "rentalStockRequest" */ '../views/RentalStockRequest/RentalStockRequestViews.vue'),
    meta: { headerTitle: 'Análise de Giro - Solicitação de Ativo' }
  },
  {
    path: '/rental-stock-request/:id',
    name: 'rentalStockRequestView',
    component: () => import(/* webpackChunkName: "rentalStockRequestView" */ '../views/RentalStockRequest/RentalStockRequestView.vue'),
    meta: { headerTitle: 'Análise de Giro - Solicitação de Ativo' }
  },
  {
    path: '/rental-stock-request/create',
    name: 'rentalStockRequestCreate',
    component: () => import(/* webpackChunkName: "rentalStockRequestCreate" */ '../views/RentalStockRequest/RentalStockRequestCreateView.vue'),
    meta: { headerTitle: 'Análise de Giro - Solicitação de Ativo' }
  },
  {
    path: '/order/ticket/:id/:type',
    name: 'OrderTicket',
    component: () => import(/* webpackChunkName: "OrderTicket" */ '../views/Order/OrderBilletView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/report/orders',
    name: 'reportOrders',
    component: () => import(/* webpackChunkName: "reportOrders" */ '../views/Report/ReportOrdersView.vue'),
    meta: { headerTitle: 'Relatório - Pedidos' }
  },
  {
    path: '/report/products',
    name: 'reportProducts',
    component: () => import(/* webpackChunkName: "reportProducts" */ '../views/Report/ReportProductsView.vue'),
    meta: { headerTitle: 'Relatório - Produtos' }
  },
  {
    path: '/report/rentals',
    name: 'reportRentals',
    component: () => import(/* webpackChunkName: "reportRentals" */ '../views/Report/ReportRentalsView.vue'),
    meta: { headerTitle: 'Relatório - Locação' }
  },
  {
    path: '/report/scrums',
    name: 'reportScrums',
    component: () => import(/* webpackChunkName: "reportScrums" */ '../views/Report/ReportScrumsView.vue'),
    meta: { headerTitle: 'Relatório - Scrum' }
  },
  {
    path: '/report/rental/prescriber',
    name: 'reportRentalPrescriber',
    component: () => import(/* webpackChunkName: "reportScrums" */ '../views/Report/ReportRentalPrescriberView.vue'),
    meta: { headerTitle: 'Relatório - Locação por Parceiro/Prescritor' }
  },
  {
    path: '/report/logistic/performance',
    name: 'reportLogisticPerformance',
    component: () => import(/* webpackChunkName: "reportLogisticPerformance" */ '../views/Report/ReportLogisticPerformanceView.vue'),
    meta: { headerTitle: 'Relatório - Performance Logística' }
  },
  {
    path: '/report/inventory',
    name: 'reportInventoryQuarter',
    component: () => import(/* webpackChunkName: "reportInventoryQuarter" */ '../views/Report/ReportInventoryQuarterView.vue'),
    meta: { headerTitle: 'Relatório - Divergência Lojas' }
  },
  {
    path: '/report/service-orders',
    name: 'reportServiceOrder',
    component: () => import(/* webpackChunkName: "reportServiceOrders" */ '../views/Report/ReportServiceOrdersView.vue'),
    meta: { headerTitle: 'Relatório - Ordens de Serviço' }
  },
  {
    path: '/goal',
    name: 'goal',
    component: () => import(/* webpackChunkName: "goal" */ '../views/Goal/GoalsView.vue'),
    meta: { headerTitle: 'Metas' }
  },
  {
    path: '/analyze',
    name: 'analyze',
    component: () => import(/* webpackChunkName: "goal" */ '../views/Analyze/AnalyzesView.vue'),
    meta: { headerTitle: 'Analisadores' }
  },
  {
    path: '/analyze/create',
    name: 'analyzeCreate',
    component: () => import(/* webpackChunkName: "goal" */ '../views/Analyze/AnalyzeCreateView.vue'),
    meta: { headerTitle: 'Analisadores' }
  },
  {
    path: '/analyze/:id',
    name: 'analyzeEdit',
    component: () => import(/* webpackChunkName: "goal" */ '../views/Analyze/AnalyzeEditView.vue'),
    meta: { headerTitle: 'Analisadores' }
  },
  {
    path: '/rental',
    name: 'rental',
    component: () => import(/* webpackChunkName: "rental" */ '../views/Rental/RentalsView.vue'),
    meta: { headerTitle: 'Locação' }
  },
  {
    path: '/rental/create',
    name: 'rentalCreate',
    component: () => import(/* webpackChunkName: "rentalCreate" */ '../views/Rental/RentalCreateView.vue'),
    meta: { headerTitle: 'Locação' }
  },
  {
    path: '/rental/:id',
    name: 'rentalView',
    component: () => import(/* webpackChunkName: "rentalView" */ '../views/Rental/RentalView.vue'),
    meta: { headerTitle: 'Locação' }
  },
  {
    path: '/rental/edit/:id',
    name: 'rentalEdit',
    component: () => import(/* webpackChunkName: "rentalEdit" */ '../views/Rental/RentalEditView.vue'),
    meta: { headerTitle: 'Locação' }
  },
  {
    path: '/rental/payment/:id',
    name: 'rentalPayment',
    component: () => import(/* webpackChunkName: "rentalPayment" */ '../views/Rental/RentalPaymentView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/rental/control-hours',
    name: 'rentalControlHoursView',
    component: () => import(/* webpackChunkName: "rentalControlHoursView" */ '../views/RentalControlHours/RentalControlHoursView.vue'),
    meta: { headerTitle: 'Controle de Horas' }
  },
  {
    path: '/rental/control-hours/create',
    name: 'rentalControlHoursCreate',
    component: () => import(/* webpackChunkName: "rentalControlHoursCreate" */ '../views/RentalControlHours/RentalControlHoursCreateView.vue'),
    meta: { headerTitle: 'Controle de Horas - Logs'}
  },
  {
    path: '/rental/control-hours/logs',
    name: 'rentalControlHoursLogs',
    component: () => import(/* webpackChunkName: "rentalControlHoursLogs" */ '../views/RentalControlHours/RentalControlHoursLogsView.vue'),
    meta: { headerTitle: 'Controle de Horas'}
  },
  {
    path: '/rental/reasons',
    name: 'rentalReasonsViews',
    component: () => import(/* webpackChunkName: "rentalControlHoursView" */ '../views/RentalReasons/RentalReasonsViews.vue'),
    meta: { headerTitle: 'Motivos' }
  },
  {
    path: '/rental/reasons/create',
    name: 'rentalReasonsCreate',
    component: () => import(/* webpackChunkName: "rentalControlHoursView" */ '../views/RentalReasons/RentalReasonsCreate.vue'),
    meta: { headerTitle: 'Motivos' }
  },
  {
    path: '/rental/reasons/:id',
    name: 'rentalReasonsEdit',
    component: () => import(/* webpackChunkName: "rentalControlHoursView" */ '../views/RentalReasons/RentalReasonsEdit.vue'),
    meta: { headerTitle: 'Motivos' }
  },
  {
    path: '/rental/report/converted',
    name: 'ReportRentalConverted',
    component: () => import(/* webpackChunkName: "rentalControlHoursView" */ '../views/Report/ReportRentalConverted.vue'),
    meta: { headerTitle: 'Relatório Locação Convertidas' }
  },
  {
    path: '/rental/report/bidding',
    name: 'ReportRentalBidding',
    component: () => import(/* webpackChunkName: "reportRentalBidding" */ '../views/Report/ReportRentalBiddingView.vue'),
    meta: { headerTitle: 'Relatório Licitação' }
  },
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import(/* webpackChunkName: "equipment" */ '../views/Equipment/EquipmentsView.vue'),
    meta: { headerTitle: 'Equipamentos'}
  },
  {
    path: '/equipment/:id',
    name: 'equipmentView',
    component: () => import(/* webpackChunkName: "equipmentView" */ '../views/Equipment/EquipmentView.vue'),
    meta: { headerTitle: 'Equipamentos'}
  },
  {
    path: '/rental-stock',
    name: 'rentalStock',
    component: () => import(/* webpackChunkName: "rental" */ '../views/RentalStock/RentalStocksView.vue'),
    meta: { headerTitle: 'Estoque - Locação'}
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import(/* webpackChunkName: "inventory" */ '../views/Inventory/InventorysView.vue'),
    meta: { headerTitle: 'Inventário - Loja'}
  },
  {
    path: '/inventory/create',
    name: 'inventoryCreate',
    component: () => import(/* webpackChunkName: "inventoryCreate" */ '../views/Inventory/InventoryCreateView.vue'),
    meta: { headerTitle: 'Inventário - Loja'}
  },
  {
    path: '/inventory/edit/:id',
    name: 'inventoryEdit',
    component: () => import(/* webpackChunkName: "inventoryEdit" */ '../views/Inventory/InventoryEditView.vue'),
    meta: { headerTitle: 'Inventário - Loja'}
  },
  {
    path: '/inventory/:id',
    name: 'inventoryShow',
    component: () => import(/* webpackChunkName: "inventoryShow" */ '../views/Inventory/InventoryShowView.vue'),
    meta: { headerTitle: 'Inventário - Loja'}
  },
  {
    path: '/inventory/result/:id',
    name: 'inventoryResult',
    component: () => import(/* webpackChunkName: "inventoryResult" */ '../views/Inventory/InventoryResultView.vue'),
    meta: { headerTitle: 'Inventário - Loja'}
  },
  {
    path: '/conference',
    name: 'conference',
    component: () => import(/* webpackChunkName: "conference" */ '../views/Conference/ConferencesView.vue'),
    meta: { headerTitle: 'Conferência - Loja'}
  },
  {
    path: '/conference/create',
    name: 'conferenceCreate',
    component: () => import(/* webpackChunkName: "conferenceCreate" */ '../views/Conference/ConferenceCreateView.vue'),
    meta: { headerTitle: 'Conferência - Loja'}
  },
  {
    path: '/conference/:id',
    name: 'conferenceShow',
    component: () => import(/* webpackChunkName: "conferenceShow" */ '../views/Conference/ConferenceShowView.vue'),
    meta: { headerTitle: 'Conferência - Loja'}
  },
  {
    path: '/conference/result/:id',
    name: 'conferenceResult',
    component: () => import(/* webpackChunkName: "conferenceResult" */ '../views/Conference/ConferenceResultView.vue'),
    meta: { headerTitle: 'Conferência - Loja'}
  },
  {
    path: '/conference/logistic',
    name: 'conferenceLogistic',
    component: () => import(/* webpackChunkName: "conferenceLogistic" */ '../views/ConferenceLogistic/ConferenceLogisticView.vue'),
    meta: { headerTitle: 'Conferência - Importação'}
  },
  {
    path: '/conference/logistic/create',
    name: 'conferenceLogisticCreate',
    component: () => import(/* webpackChunkName: "conferenceLogisticCreate" */ '../views/ConferenceLogistic/ConferenceLogisticCreateView.vue'),
    meta: { headerTitle: 'Conferência - Importação'}
  },
  {
    path: '/conference/logistic/:id',
    name: 'conferenceLogisticShow',
    component: () => import(/* webpackChunkName: "conferenceLogisticShow" */ '../views/ConferenceLogistic/ConferenceLogisticShowView.vue'),
    meta: { headerTitle: 'Conferência - Importação'}
  },
  {
    path: '/spreadsheet',
    name: 'spreadsheet',
    component: () => import(/* webpackChunkName: "spreadsheet" */ '../views/Spreadsheets/SpreadSheetViews.vue'),
    meta: { headerTitle: 'Conferência - Importação - Planilhas'}
  },
  {
    path: '/spreadsheet/create',
    name: 'spreadhSheetCreate',
    component: () => import(/* webpackChunkName: "spreadhSheetCreate" */ '../views/Spreadsheets/SpreadsheetCreateView.vue'),
    meta: { headerTitle: 'Conferência - Importação - Planilhas'}
  },
  {
    path: '/spreadsheet/:id',
    name: 'spreadsheetView',
    component: () => import(/* webpackChunkName: "spreadsheetView" */ '../views/Spreadsheets/SpreadSheetView.vue'),
    meta: { headerTitle: 'Conferência - Importação - Planilhas'}
  },
  {
    path: '/inventory/analysis',
    name: 'inventoryAnalysis',
    component: () => import(/* webpackChunkName: "spreadsheet" */ '../views/InventoryAnalysis/InventoryAnalysisViews.vue'),
    meta: { headerTitle: 'Análise de Inventário'}
  },
  {
    path: '/inventory/analysis/:id',
    name: 'inventoryAnalysisView',
    component: () => import(/* webpackChunkName: "spreadsheet" */ '../views/InventoryAnalysis/InventoryAnalysisView.vue'),
    meta: { headerTitle: 'Análise de Inventário'}
  },
  {
    path: '/inventory/analysis/:id/show',
    name: 'inventoryAnalysisShow',
    component: () => import(/* webpackChunkName: "spreadsheet" */ '../views/InventoryAnalysis/InventoryAnalysisShowView.vue'),
    meta: { headerTitle: 'Análise de Inventário'}
  },
  {
    path:'/conference/entrance',
    name:'conferenceEntrance',
    component: () => import(/* webpackChunkName: "conferenceEntrance" */ '../views/ConferenceEntrance/ConferenceEntrancesView.vue'),
    meta: { headerTitle: 'Conferência - Entrada'}
  },
  {
    path:'/conference/entrance/create',
    name:'conferenceEntranceCreate',
    component: () => import(/* webpackChunkName: "conferenceEntranceCreate" */ '../views/ConferenceEntrance/ConferenceEntranceCreateView.vue'),
    meta: { headerTitle: 'Conferência - Entrada'}
  },
  {
    path:'/conference/entrance/:id',
    name:'conferenceEntranceShow',
    component: () => import(/* webpackChunkName: "conferenceEntranceShow" */ '../views/ConferenceEntrance/ConferenceEntranceShowView.vue'),
    meta: { headerTitle: 'Conferência - Entrada'}
  },
  {
    path: '/inventory/logistic',
    name: 'inventoryLogistic',
    component: () => import(/* webpackChunkName: "inventory" */ '../views/InventoryLogistic/InventorysView.vue'),
    meta: { headerTitle: 'Inventário - Logística'}
  },
  {
    path: '/inventory/logistic/edit/:id',
    name: 'inventoryLogisticEdit',
    component: () => import(/* webpackChunkName: "inventoryLogisticEdit" */ '../views/InventoryLogistic/InventoryEditView.vue'),
    meta: { headerTitle: 'Inventário - Logística'}
  },
  {
    path: '/inventory/logistic/:id',
    name: 'inventoryLogisticShow',
    component: () => import(/* webpackChunkName: "inventoryLogisticShow" */ '../views/InventoryLogistic/InventoryShowView.vue'),
    meta: { headerTitle: 'Inventário - Logística'}
  },
  {
    path: '/inventory/logistic/:id/items',
    name: 'inventoryLogisticItemsShow',
    component: () => import(/* webpackChunkName: "inventoryLogisticItemsShow" */ '../views/InventoryLogistic/InventoryProductShowView.vue'),
    meta: { headerTitle: 'Inventário - Logística'}
  },
  {
    path: '/inventory/logistic/:id/result',
    name: 'inventoryLogisticResultShow',
    component: () => import(/* webpackChunkName: "inventoryLogisticResultShow" */ '../views/InventoryLogistic/InventoryProductResultView.vue'),
    meta: { headerTitle: 'Inventário - Logística'}
  },
  {
    path: '/inventory/single-count',
    name: 'singleCountsView',
    component: () => import(/* webpackChunkName: "singleCountsView" */ '../views/SingleCount/SingleCountsView.vue'),
    meta: { headerTitle: 'Inventário - Contagem Avulsa'}
  },
  {
    path: '/inventory/single-count/create',
    name: 'singleCountCreate',
    component: () => import(/* webpackChunkName: "singleCountCreate" */ '../views/SingleCount/SingleCountCreateView.vue'),
    meta: { headerTitle: 'Inventário - Contagem Avulsa'}
  },
  {
    path: '/inventory/single-count/:id',
    name: 'singleCountShow',
    component: () => import(/* webpackChunkName: "singleCountShow" */ '../views/SingleCount/SingleCountShowView.vue'),
    meta: { headerTitle: 'Inventário - Contagem Avulsa'}
  },
  {
    path: '/inventory/tech-assist',
    name: 'techAssistInventory',
    component: () => import(/* webpackChunkName: "TechAssistInventory" */ '../views/TechAssistInventory/TechAssistInventorysView.vue'),
    meta: { headerTitle: 'Inventário - Assistência Técnica'}
  },
  {
    path: '/inventory/tech-assist/create',
    name: 'techAssistInventoryCreate',
    component: () => import(/* webpackChunkName: "TechAssistInventoryCreate" */ '../views/TechAssistInventory/TechAssistInventoryCreateView.vue'),
    meta: { headerTitle: 'Inventário - Assistência Técnica'}
  },
  {
    path: '/inventory/tech-assist/:id',
    name: 'techAssistInventoryShow',
    component: () => import(/* webpackChunkName: "techAssistInventoryShow" */ '../views/TechAssistInventory/TechAssistInventoryShowView.vue'),
    meta: { headerTitle: 'Inventário - Assistência Técnica'},
  },
  {
    path: '/inventory/tech-assist/edit/:id',
    name: 'techAssistInventoryEdit',
    component: () => import(/* webpackChunkName: "techAssistInventoryEdit" */ '../views/TechAssistInventory/TechAssistInventoryEditView.vue'),
    meta: { headerTitle: 'Inventário - Assistência Técnica'}
  },
  {
    path: '/inventory/tech-assist/result/:id',
    name: 'techAssistInventoryResult',
    component: () => import(/* webpackChunkName: "techAssistInventoryResult" */ '../views/TechAssistInventory/TechAssistInventoryResultView.vue'),
    meta: { headerTitle: 'Inventário - Assistência Técnica'}
  },
  {
    path: '/stockroom',
    name: 'stockrooms',
    component: () => import(/* webpackChunkName: "stockrooms" */ '../views/StockRoom/StockRoomViews.vue'),
    meta: { headerTitle: 'Solicitação de Compra'}
  },
  {
    path: '/stockroom/create',
    name: 'stockroomCreate',
    component: () => import(/* webpackChunkName: "stockroomCreate" */ '../views/StockRoom/StockRoomCreateView.vue'),
    meta: { headerTitle: 'Solicitação de Compra'}
  },
  {
    path: '/stockroom/:id',
    name: 'stockroomView',
    component: () => import(/* webpackChunkName: "stockroomView" */ '../views/StockRoom/StockRoomView.vue'),
    meta: { headerTitle: 'Solicitação de Compra'}
  },
  {
    path: '/stockroom/edit/:id',
    name: 'stockroomEdit',
    component: () => import(/* webpackChunkName: "stockroomEditView" */ '../views/StockRoom/StockRoomEditView.vue'),
    meta: { headerTitle: 'Solicitação de Compra'}
  },
  {
    path: '/stockroom/products',
    name: 'stockroomProducts',
    component: () => import(/* webpackChunkName: "stockroomProducts" */ '../views/StockRoom/StockRoomProductsView.vue'),
    meta: { headerTitle: 'Produtos - Solicitação de Compra'}
  },
  {
    path: '/type-service-order',
    name: 'typeServiceOrder',
    component: () => import(/* webpackChunkName: "typeServiceOrder" */ '../views/TypeServiceOrder/TypeServiceOrdersView.vue'),
    meta: { headerTitle: 'Tipos de OS'}
  },
  {
    path: '/type-service-order/create',
    name: 'typeServiceOrderCreate',
    component: () => import(/* webpackChunkName: "typeServiceOrderCreate" */ '../views/TypeServiceOrder/TypeServiceOrderCreateView.vue'),
    meta: { headerTitle: 'Tipos de OS'}
  },
  {
    path: '/type-service-order/:id',
    name: 'typeServiceOrderEdit',
    component: () => import(/* webpackChunkName: "typeServiceOrderEdit" */ '../views/TypeServiceOrder/TypeServiceOrderEditView.vue'),
    meta: { headerTitle: 'Tipos de OS'}
  },
  {
    path: '/reverse-logistic',
    name: 'reverseLogistic',
    component: () => import(/* webpackChunkName: "reverseLogistic" */ '../views/ReverseLogistic/ReverseLogisticView.vue'),
    meta: { headerTitle: 'Correios - Logística Reversa'}
  },
  {
    path: '/service-order',
    name: 'serviceOrder',
    component: () => import(/* webpackChunkName: "serviceOrder" */ '../views/ServiceOrder/ServiceOrdersView.vue'),
    meta: { headerTitle: 'Ordens de Serviço'}
  },
  {
    path: '/service-order/create',
    name: 'serviceOrderCreate',
    component: () => import(/* webpackChunkName: "serviceOrderCreate" */ '../views/ServiceOrder/ServiceOrderCreateView.vue'),
    meta: { headerTitle: 'Ordens de Serviço'}
  },
  {
    path: '/service-order/:id',
    name: 'serviceOrderView',
    component: () => import(/* webpackChunkName: "serviceOrderView" */ '../views/ServiceOrder/ServiceOrderView.vue'),
    meta: { headerTitle: 'Ordens de Serviço'}
  },
  {
    path: '/service-order/:id/equipment',
    name: 'ServiceOrderEquipment',
    component: () => import(/* webpackChunkName: "ServiceOrderEquipment" */ '../views/ServiceOrder/ServiceOrderEquipmentView.vue'),
    meta: { headerTitle: 'Equipamentos'}
  },
  {
    path: '/service-order-equipment',
    name: 'ServiceOrderEquipments',
    component: () => import(/* webpackChunkName: "ServiceOrderEquipments" */ '../views/ServiceOrder/ServiceOrderEquipmentsView.vue'),
    meta: { headerTitle: 'Equipamentos'}
  },
  {
    path: '/service-order-equipment/for-donation',
    name: 'ServiceOrderEquipmentsForDonation',
    component: () => import(/* webpackChunkName: "ServiceOrderEquipmentsForDonation" */ '../views/ServiceOrder/ServiceOrderEquipmentsForDonationViews.vue'),
    meta: { headerTitle: 'Equipamentos - Doação'}
  },
  {
    path: '/service-order/parts-management',
    name: 'ServiceOrderPartsManagement',
    component: () => import(/* webpackChunkName: "ServiceOrderPartsManagement" */ '../views/ServiceOrder/ServiceOrderPartsManagementView.vue'),
    meta: { headerTitle: 'Ordem de Serviço - Gestão de Peças'}
  },
  {
    path: '/service-order/parts-management/:id',
    name: 'ServiceOrderPartsManagementShow',
    component: () => import(/* webpackChunkName: "ServiceOrderPartsManagementShow" */ '../views/ServiceOrder/ServiceOrderPartsManagamenetShowView.vue'),
    meta: { headerTitle: 'Ordem de Serviço - Gestão de Peças'}
  },
  {
    path: '/service-order/:id/budget',
    name: 'ServiceOrderBudget',
    component: () => import(/* webpackChunkName: "ServiceOrderBudget" */ '../views/ServiceOrder/ServiceOrderBudgetView.vue'),
    meta: { headerTitle: 'Orçamento'}
  },
  {
    path: '/service-order-budget/:id',
    name: 'ServiceOrderBudgetPublic',
    component: () => import(/* webpackChunkName: "ServiceOrderBudget" */ '../views/ServiceOrder/ServiceOrderBudgetPublicView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/service-order/GeneratedOrderView',
    name: 'GeneratedOrderView.vue',
    component: () => import(/* webpackChunkName: "GeneratedOrderView.vue" */ '../views/ServiceOrder/GeneratedOrderView.vue')
  },
  {
    path: '/service-order/SalesReceiptView',
    name: 'SalesReceiptView.vue',
    component: () => import(/* webpackChunkName: "SalesReceiptView.vue" */ '../views/ServiceOrder/SalesReceiptView.vue')
  },
  {
    path: '/service-order/:id/:type',
    name: 'serviceOrderRequest',
    component: () => import(/* webpackChunkName: "serviceOrderRequest" */ '../views/ServiceOrder/ServiceOrderRequestView.vue'),
    meta: { headerTitle: 'Pedidos'}
  },
  {
    path: '/service-order/PaymentServiceOrderView',
    name: 'PaymentServiceOrderView.vue',
    component: () => import(/* webpackChunkName: "PaymentServiceOrderView.vue" */ '../views/ServiceOrder/PaymentServiceOrderView.vue')
  },
  {
    path: '/service-order/ServiceOrderSendPaymentView',
    name: 'ServiceOrderSendPaymentView.vue',
    component: () => import(/* webpackChunkName: "ServiceOrderSendPaymentView.vue" */ '../views/ServiceOrder/ServiceOrderSendPaymentView.vue')
  },
  {
    path: '/service-order/services',
    name: 'serviceOrderServices',
    component: () => import(/* webpackChunkName: "serviceOrderServices" */ '../views/Service/ServiceOrderServicesView.vue'),
    meta: { headerTitle: 'Serviços de OS'}
  },
  {
    path: '/service-order/requests',
    name: 'serviceOrderRequests',
    component: () => import(/* webpackChunkName: "serviceOrderOrders" */ '../views/ServiceOrder/ServiceOrderRequestsView.vue'),
    meta: { headerTitle: 'Pedidos de OS'}
  },
  {
    path: '/service-order/report',
    name: 'serviceOrderReport',
    component: () => import(/* webpackChunkName: "serviceOrderOrders" */ '../views/ServiceOrder/ServiceOrderReportView.vue'),
    meta: { headerTitle: 'Relatório de OS x Locação'}
  },
  {
    path: '/service-order/dashboard',
    name: 'serviceOrderDashBoard',
    component: () => import(/* webpackChunkName: "serviceOrderDashBoard" */ '../views/ServiceOrder/ServiceOrderDashBoardView.vue'),
    meta: { headerTitle: 'Dashboard AT'}
  },
  {
    path: '/employee/:id',
    name: 'employee',
    component: () => import(/* webpackChunkName: "employe" */ '../views/Employees/EmployeesCreateView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/employee/onboarding-feedback/:id',
    name: 'employeeOnboardFeedback',
    component: () => import(/* webpackChunkName: "employe" */ '../views/Employees/EmployeeOnboardingFeedbackView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/uptime/:hash',
    name: 'uptime',
    component: () => import(/* webpackChunkName: "uptime" */ '../views/Uptime/UptimeView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/scrum',
    name: 'scrums',
    component: () => import(/* webpackChunkName: "ScrumsView.vue" */ '../views/Scrum/ScrumsView.vue'),
    meta: { headerTitle: 'Scrum'}
  },
  {
    path: '/scrum/create',
    name: 'scrumCreate',
    component: () => import(/* webpackChunkName: "ScrumsView.vue" */ '../views/Scrum/ScrumCreateView.vue'),
    meta: { headerTitle: 'Scrum'}
  },
  {
    path: '/scrum/:id/sprint',
    name: 'scrumSprint',
    component: () => import(/* webpackChunkName: "SprintView.vue" */ '../views/Scrum/SprintView.vue'),
    meta: { headerTitle: 'Scrum'}
  },
  {
    path: '/scrum/:scrum/sprint/:sprint/tasks',
    name: 'scrumSprintTasks',
    component: () => import(/* webpackChunkName: "SprintView.vue" */ '../views/Scrum/TasksViews.vue'),
    meta: { headerTitle: 'Scrum'}
  },
  {
    path: '/fte',
    name: 'fte',
    component: () => import(/* webpackChunkName: "fte" */ '../views/Fte/FtesView.vue'),
    meta: { headerTitle: 'FTE'}
  },
  {
    path: '/fte/create',
    name: 'fteCreate',
    component: () => import(/* webpackChunkName: "fteCreate" */ '../views/Fte/FteCreateView.vue'),
    meta: { headerTitle: 'FTE'}
  },
  {
    path: '/fte/:id',
    name: 'fteEdit',
    component: () => import(/* webpackChunkName: "fteEdit" */ '../views/Fte/FteEditView.vue'),
    meta: { headerTitle: 'FTE'}
  },
  {
    path: '/sectors',
    name: 'sector',
    component: () => import(/* webpackChunkName: "sector" */ '../views/Sectors/SectorViews.vue'),
    meta: { headerTitle: 'Setores'}
  },
  {
    path: '/sectors/create',
    name: 'sectorCreate',
    component: () => import(/* webpackChunkName: "sector" */ '../views/Sectors/SectorCreateView.vue'),
    meta: { headerTitle: 'Setores'}
  },
  {
    path: '/sectors/:id',
    name: 'sectorEdit',
    component: () => import(/* webpackChunkName: "sector" */ '../views/Sectors/SectorEditView.vue'),
    meta: { headerTitle: 'Setores'}
  },
  {
    path: '/category',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category/CategoryViews.vue'),
    meta: { headerTitle: 'Categorias'}
  },
  {
    path: '/category/create',
    name: 'categoryCreate',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category/CategoryCreateView.vue'),
    meta: { headerTitle: 'Categorias'}
  },
  {
    path: '/category/:id',
    name: 'categoryEdit',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category/CategoryEditView.vue'),
    meta: { headerTitle: 'Categorias'}
  },
  {
    path: '/sub-category',
    name: 'subCategory',
    component: () => import(/* webpackChunkName: "subCategory" */ '../views/SubCategory/SubCategoryViews.vue'),
    meta: { headerTitle: 'Sub-Categorias'}
  },
  {
    path: '/sub-category/create',
    name: 'subCategoryCreate',
    component: () => import(/* webpackChunkName: "subCategory" */ '../views/SubCategory/SubCategoryCreateView.vue'),
    meta: { headerTitle: 'Sub-Categorias'}
  },
  {
    path: '/sub-category/:id',
    name: 'subCategoryEdit',
    component: () => import(/* webpackChunkName: "subCategory" */ '../views/SubCategory/SubCategoryEditView.vue'),
    meta: { headerTitle: 'Sub-Categorias'}
  },
  {
    path: '/additional-options',
    name: 'additionalOptions',
    component: () => import(/* webpackChunkName: "additionalOptions" */ '../views/AdditionalOptions/AdditionalOptionsViews.vue'),
    meta: { headerTitle: 'Opções Adicionais'}
  },
  {
    path: '/additional-options/create',
    name: 'additionalOptionsCreate',
    component: () => import(/* webpackChunkName: "additionalOptions" */ '../views/AdditionalOptions/AdditionalOptionsCreateView.vue'),
    meta: { headerTitle: 'Opções Adicionais'}
  },
  {
    path: '/additional-options/:id',
    name: 'additionalOptionsEdit',
    component: () => import(/* webpackChunkName: "additionalOptions" */ '../views/AdditionalOptions/AdditionalOptionsEditView.vue'),
    meta: { headerTitle: 'Opções Adicionais'}
  },
  {
    path: '/fields',
    name: 'fields',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Fields/FieldsViews.vue'),
    meta: { headerTitle: 'Campos'}
  },
  {
    path: '/fields/create',
    name: 'fieldsCreate',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Fields/FieldsCreateView.vue'),
    meta: { headerTitle: 'Campos'}
  },
  {
    path: '/fields/:id',
    name: 'fieldsEdit',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Fields/FieldsEditView.vue'),
    meta: { headerTitle: 'Campos'}
  },
  {
    path: '/templates',
    name: 'templates',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Templates/TemplateViews.vue'),
    meta: { headerTitle: 'Templates'}
  },
  {
    path: '/templates/create',
    name: 'templatesCreate',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Templates/TemplateCreateView.vue'),
    meta: { headerTitle: 'Templates'}
  },
  {
    path: '/templates/:id',
    name: 'templatesEdit',
    component: () => import(/* webpackChunkName: "fields" */ '../views/Templates/TemplatesEditVIew.vue'),
    meta: { headerTitle: 'Templates'}
  },
  {
    path: '/task-create/public',
    name: 'taskCreatePublic',
    component: () => import(/* webpackChunkName: "taskCreatePublic" */ '../views/Templates/TaskCreatePublicView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: () => import(/* webpackChunkName: "cashier" */ '../views/Cashier/CashierViews.vue'),
    meta: { headerTitle: 'Caixas - Gerência'}
  },
  {
    path: '/cashier/:id',
    name: 'cashierView',
    component: () => import(/* webpackChunkName: "cashierLogs" */ '../views/Cashier/CashierView.vue'),
    meta: { headerTitle: 'Caixas - Gerência'}
  },
  {
    path: '/budget',
    name: 'budget',
    component: () => import(/* webpackChunkName: "budget" */ '../views/Budget/BudgetViews.vue'),
    meta: { headerTitle: 'Orçamento'}
  },
  {
    path: '/budget/create',
    name: 'budgetCreate',
    component: () => import(/* webpackChunkName: "budgetCreate" */ '../views/Budget/BudgetCreateView.vue'),
    meta: { headerTitle: 'Orçamento'}
  },
  {
    path: '/budget/:id',
    name: 'BudgetView',
    component: () => import(/* webpackChunkName: "BudgetView" */ '../views/Budget/BudgetView.vue'),
    meta: { headerTitle: 'Orçamento'}
  },
  {
    path: '/wallpapers',
    name: 'wallpapersView',
    component: () => import(/* webpackChunkName: "wallpapersView" */ '../views/Wallpapers/WallpapersView.vue')
  },
  {
    path: '/wallpapers/create',
    name: 'wallpapersCreate',
    component: () => import(/* webpackChunkName: "wallpapersCreate" */ '../views/Wallpapers/WallpaperCreateView.vue')
  },
  {
    path: '/all-status',
    name:'allStatus',
    component: () => import(/* webpackChunkName: "allStatus" */ '../views/Status/AllStatusView.vue'),
    meta: { headerTitle: 'Status'}
  },
  {
    path:'/employee/assessment/:id',
    name:'assesment',
    component: () => import(/* webpackChunkName: "allStatus" */ '../views/Assesment/AssesmentView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true,
    }
  },
  {
    path: '/billing-manage',
    name: 'billingManage',
    component: () => import(/* webpackChunkName: "billingManage" */ '../views/BillingManage/BillingManageView.vue'),
    meta: { headerTitle: 'Gestão de Cobranças'}
  },
  {
    path: '/mail',
    name: 'mail',
    component: () => import(/* webpackChunkName: "allStatus" */ '../views/Mails/MailView.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true,
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ/FAQView.vue'),
    meta: { headerTitle: 'FAQ'}
  },
  {
    path: '/faq/create',
    name: 'faqCreate',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ/FAQCreateView.vue'),
    meta: { headerTitle: 'FAQ'}
  },
  {
    path: '/faq/edit/:id',
    name: 'faqEdit',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ/FAQCreateView.vue'),
    meta: { headerTitle: 'FAQ'}
  },
  {
    path: '/tag/manage',
    name: 'tagManage',
    component: () => import(/* webpackChunkName: "tags" */ '../views/Tag/TagsView.vue'),
    meta: { headerTitle: 'Gerenciar Tags'}
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: () => import(/* webpackChunkName: "exchange" */ '../views/Exchange/ExchangeViews.vue'),
    meta: { headerTitle: 'Trocas - Solicitações'}
  },
  {
    path: '/exchange/create',
    name: 'exchangeCreate',
    component: () => import(/* webpackChunkName: "exchangeCreate" */ '../views/Exchange/ExchangeCreateView.vue'),
    meta: { headerTitle: 'Trocas - Solicitações'}
  },
  {
    path: '/exchange/:id',
    name: 'exchangeView',
    component: () => import(/* webpackChunkName: "ExchangeView" */ '../views/Exchange/ExchangeView.vue'),
    meta: { headerTitle: 'Trocas - Solicitações'}
  },
  {
    path: '/exchange/reasons',
    name: 'exchangeReasons',
    component: () => import(/* webpackChunkName: "exchangeReasons" */ '../views/ExchangeReasons/ExchangeReasonsView.vue'),
    meta: { headerTitle: 'Trocas - Motivos'}
  },
  {
    path: '/exchange/reasons/create',
    name: 'exchangeReasonsCreate',
    component: () => import(/* webpackChunkName: "exchangeReasonsCreate" */ '../views/ExchangeReasons/ExchangeReasonCreateView.vue'),
    meta: { headerTitle: 'Trocas - Motivos'}
  },
  {
    path: '/exchange/reasons/:id',
    name: 'exchangeReasonsEdit',
    component: () => import(/* webpackChunkName: "exchangeReasonsEdit" */ '../views/ExchangeReasons/ExchangeReasonsEditView.vue'),
    meta: { headerTitle: 'Trocas - Motivos'}
  },
  {
    path: '/exchange/rejection-reasons',
    name: 'exchangeRejectionReasons',
    component: () => import(/* webpackChunkName: "exchangeRejectionReasons" */ '../views/ExchangeRejectionReasons/ExchangeRejectionReasonsView.vue'),
    meta: { headerTitle: 'Trocas - Motivos de Reprovação'}
  },
  {
    path: '/exchange/rejection-reasons/create',
    name: 'exchangeRejectionReasonsCreate',
    component: () => import(/* webpackChunkName: "exchangeRejectionReasonsCreate" */ '../views/ExchangeRejectionReasons/ExchangeRejectionReasonCreateView.vue'),
    meta: { headerTitle: 'Trocas - Motivos de Reprovação'}
  },
  {
    path: '/exchange/rejection-reasons/:id',
    name: 'exchangeRejectionReasonsEdit',
    component: () => import(/* webpackChunkName: "exchangeRejectionReasonsEdit" */ '../views/ExchangeRejectionReasons/ExchangeRejectionReasonsEditView.vue'),
    meta: { headerTitle: 'Trocas - Motivos de Reprovação'}
  },
  {
    path: '/exchange/products-manage',
    name: 'exchangeProductsManage',
    component: () => import(/* webpackChunkName: "exchangeProductsManage" */ '../views/UsedProductsExchangeManage/UsedProductsExchangeManageViews.vue'),
    meta: { headerTitle: 'Trocas - Gestão de Produtos Usados de Troca'}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from) => {
  let title

  if (typeof to.meta.headerTitle === 'function') {
    title = to.meta.headerTitle(to);
  } else if (typeof to.meta.headerTitle === 'string') {
    title = to.meta.headerTitle;
  }

  store.dispatch('updateHeaderTitle', title);
  const isPublic = to?.matched?.some(record => record?.meta?.public);
  const onlyWhenLoggedOut = to?.matched.some(
      record => record?.meta?.onlyWhenLoggedOut
  );
  const loggedIn = (getStorage('loggedIn') === 'true')
  let redirect = from?.fullPath.indexOf('forgot-password') !== -1 ? '' : from?.fullPath;
  if (!redirect || redirect.indexOf('?redirect=')) {
    redirect = String(from?.query.redirect) ?? ''
  }

  if (!isPublic && !loggedIn) {
    return {
      path: "/",
      query: { redirect: redirect }
    };
  }
  if (loggedIn && to.fullPath == '/') {
    return {
      path: "/home"
    };
  }

  if ((redirect && redirect != 'undefined') && loggedIn) {
    delete from?.query.redirect;
    return {path: redirect}
  }
});

export default router
